import kitchens from "@/apis/kitchens/kitchens";
import { kitchensTypes } from "@/store/mutationTypes";

export default {
  namespaced: true,
  state: {
    all: null,
    fetchAll: {
      pending: false,
      error: null,
    },
  },
  mutations: {
    [kitchensTypes.FETCH_ALL_REQUEST]: function(state) {
      state.fetchAll.pending = true;
    },
    [kitchensTypes.FETCH_ALL_SUCCESS]: function(state, kitchens) {
      state.all = kitchens;
      state.fetchAll.error = null;
      state.fetchAll.pending = false;
    },
    [kitchensTypes.FETCH_ALL_FAILURE]: function(state, error) {
      state.all = null;
      state.fetchAll.error = error;
      state.fetchAll.pending = false;
    },
  },
  actions: {
    async fetchAll({ commit }) {
      commit(kitchensTypes.FETCH_ALL_REQUEST);
      return new Promise((resolve, reject) => {
        kitchens
          .fetchAll({ include_secrets: false, include_restaurants: false })
          .then((kitchensList) => {
            commit(kitchensTypes.FETCH_ALL_SUCCESS, kitchensList.data);
            resolve(kitchensList.data);
          })
          .catch((error) => {
            commit(kitchensTypes.FETCH_ALL_FAILURE, error);
            reject(error);
          });
      });
    },
  },
};
